/*
 * @Descripttion: 收银软件
 * @version: 1.0.0
 * @Author: ck
 * @Date: 2019-10-15 15:48:03
 * @LastEditors: ck
 * @LastEditTime: 2019-10-15 15:50:32
 */

const _load = require('@/routers/_loadPath/_load_' + process.env.NODE_ENV)
let cashier = _load('product/software/cashier/Index')
let retail = _load('product/software/retail/Index')
const routes = [{
    path: 'software/cashier',
    component: cashier,
    name: 'cashier',
    meta: {
      title: '传贝收银'
    },
  },
  {
    path: 'software/retail',
    component: retail,
    name: 'retail',
    meta: {
      title: '传贝零售收银系统'
    },
  }
];

export default routes